<template>
  <sidebar-items-list
      :api-url="apiUrl"
      :back-to="{ name: 'projects.show', params: { projectId } }"
      :header="$t('Floors')"
      model-type="floor"
  >
    <template #default="{items}">
      <b-list-group-item
          v-for="floor in items"
          :key="floor.id"
          class="justify-between"
          tag="li"
      >
        <b-link
            :to="{
                            name: 'projects.components.floors.show',
                            params: { projectId, componentId, floorId: floor.id }
                        }"
            class="flex-grow-1"
        >
          {{ floor.name }}
          <small v-if="floor.short_name" class="d-block">{{ floor.short_name }}</small>
        </b-link>

        <list-item-buttons
            :api-url="apiUrl"
            :item="floor"
            show-clone-options
            @deleted="items.splice(items.indexOf($event), 1)"
            @duplicated="items.push($event)"
        >
          <template slot="prepend">
            <complete-services
                :api-url="`/api/floors/${floor.id}/services_to_complete`"
                :project-id="+projectId"
            >
              <template #activator="{toggle}">
                <b-button
                    :title="$t('Complete services')"
                    style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                    variant="success"
                    @click="toggle"
                >
                  <fa :title="$t('Complete services')" fixed-width icon="check" />
                </b-button>
              </template>

              <template #services="{form, services}">
                <tree-view
                    v-model="form.walls"
                    :errors="form.errors"
                    :items="services.walls"
                    :label="$t('Walls')"
                    class="mt-3"
                    error-prefix="walls"
                    label-by="name"
                />

                <tree-view
                    v-model="form.elements"
                    :errors="form.errors"
                    :items="services.elements"
                    :label="$t('Elements')"
                    class="mt-3"
                    error-prefix="elements"
                    label-by="name"
                />
              </template>
            </complete-services>
          </template>
        </list-item-buttons>
      </b-list-group-item>
    </template>
  </sidebar-items-list>
</template>
<script>
import ListItemButtons from "@/components/ListItemButtons";
import TreeView from "@/components/TreeView";
import CompleteServices from "@/components/projects/CompleteServices";
import SidebarItemsList from "@/components/SidebarItemsList";

export default {
  name: 'Floors',
  components: {SidebarItemsList, CompleteServices, TreeView, ListItemButtons},
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    componentId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    apiUrl() {
      return '/api/projects/' + this.projectId + '/components/' + this.componentId + '/floors';
    },
  },
};
</script>
